"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerContentWrapper = exports.BannerWrapper = exports.CircleIconWrapper = exports.CompanySubscriptionHeader = exports.StyledBadge = exports.CompanyWebsiteLink = exports.SubscribersText = exports.SubscribersWrapper = exports.MenuHeaderTitle = exports.SubNavigationContentWrapper = exports.HeaderTitle = exports.EntryText = exports.EditButtonWrapper = exports.HeaderTextInfo = exports.SubContentPagesNavigationWrapper = exports.StyledWebIcon = exports.SubNavigation = exports.SubSectionButton = exports.EditButton = exports.ImageBlock = exports.HeaderContent = exports.HeaderTextWrapper = exports.HeaderEntryWrapper = exports.FullHeaderWrapper = exports.TitleImageOverlay = exports.Header = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@ant-design/icons");
const polished_1 = require("polished");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.Header = styled_components_1.default.div `
	position: relative;
	width: 100%;
	height: 28rem;
	min-height: 100%;
	background: url(${props => props.background}) no-repeat 50%;
	background-size: cover;
	object-fit: cover;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.TitleImageOverlay = styled_components_1.default.div `
	position: absolute;
	color: ${props => props.theme.color.white};
	width: 100%;
	height: 100%;
	display: flex;
	font-size: ${props => props.theme.fontSizes.m};
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.4);
	opacity: 1;
	z-index: 1;
`;
exports.FullHeaderWrapper = styled_components_1.default.div `
	position: relative;
	max-width: ${({ theme }) => theme.breakpoints.xl};
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
	height: 100%;
	width: 100%;
	padding: 0 1rem;
`;
exports.HeaderEntryWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: start;
	margin-bottom: 0.5rem;
	text-align: left;
	svg {
		min-width: 1rem;
	}
	${(0, styled_breakpoints_1.up)('sm')} {
		margin-bottom: 0.5rem;
	}
	${(0, styled_breakpoints_1.up)('md')} {
		margin-bottom: 0;
		justify-content: start;
	}
`;
exports.HeaderTextWrapper = styled_components_1.default.div `
	z-index: inherit;
	color: ${props => props.theme.color.white};
	${(0, styled_breakpoints_1.up)('md')} {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
	${(0, styled_breakpoints_1.up)('lg')} {
		flex-direction: row;
	}
`;
exports.HeaderContent = styled_components_1.default.div `
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-direction: column;
	z-index: 2;
	margin-top: 0;
	${(0, styled_breakpoints_1.up)('md')} {
		position: absolute;
		left: 1rem;
		bottom: ${({ hasImage }) => (hasImage ? 0 : '1rem')};
		display: flex;
		flex-direction: row;
		height: unset;
		justify-content: flex-end;
	}
`;
exports.ImageBlock = styled_components_1.default.div `
	border: 1px solid ${({ theme }) => theme.color.gray8};
	background: ${({ theme }) => theme.color.white};
	z-index: inherit;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.25rem;
	margin: 0 0 0.5rem;
	& > * {
		padding: 4px;
		background: white;
		max-width: 100%;
		max-height: 100%;
	}

	svg {
		width: 70%;
		height: 70%;
		color: ${({ theme }) => theme.color.gray4};
	}
	${(0, styled_breakpoints_1.up)('md')} {
		margin: 0 1rem 1rem 0;
	}
`;
exports.EditButton = (0, styled_components_1.default)(elements_1.Button) `
	color: ${({ theme }) => theme.color.white};
	border: 1px solid ${({ theme }) => theme.color.white};
	z-index: inherit;

	:hover {
		background-color: ${props => (0, polished_1.darken)(0.3, props.theme.color.white)};
	}´

`;
exports.SubSectionButton = styled_components_1.default.div `
	height: 100%;
	display: flex;
	align-items: center;
	border-bottom: 0.25rem solid ${props => (props.isActive ? props.theme.color.brand3 : 'transparent')};
	transition: 0.15s;
	white-space: nowrap;
	color: ${({ isActive, theme }) => (isActive ? theme.color.brand3 : (0, polished_1.transparentize)(0.2, theme.color.gray8))};
	font-weight: bold;
	font-size: 1rem;
	text-transform: uppercase;
	margin: 0 0.5rem;
	padding: 0.5rem 0 0.25rem;
	:hover {
		color: ${props => (0, polished_1.darken)(0.2, props.theme.color.brand3)};
		cursor: pointer;
	}
	${(0, styled_breakpoints_1.up)('md')} {
		padding: 1rem 0.25rem 0.75rem;
		margin: 0 0.5rem 0 0;
	}
`;
exports.SubNavigation = styled_components_1.default.div `
	transition: all 0.15s ease;
	position: sticky;
	top: ${({ isMenuSticked }) => (isMenuSticked ? '5rem' : '0rem')};
	z-index: 999;
	width: 100%;
	background: ${({ theme }) => theme.color.gray3};
	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: center;
		position: unset;
	}
`;
exports.StyledWebIcon = (0, styled_components_1.default)(icons_1.GlobalOutlined) `
	svg {
		width: 0.875rem;
		height: 0.875rem;
	}
`;
exports.SubContentPagesNavigationWrapper = styled_components_1.default.div `
	display: flex;
	overflow-x: auto;
	max-width: ${({ theme }) => theme.breakpoints.xl};
	width: 100%;
`;
exports.HeaderTextInfo = styled_components_1.default.div `
	text-align: center;
	${(0, styled_breakpoints_1.up)('md')} {
		text-align: unset;
	}
`;
exports.EditButtonWrapper = styled_components_1.default.div `
	padding: 1rem 1rem 0;
	width: 100%;
	display: flex;
	justify-content: end;
	z-index: 2;
	max-width: ${({ theme }) => theme.breakpoints.xl};
`;
exports.EntryText = styled_components_1.default.div `
	font-size: 0.75rem;

	${(0, styled_breakpoints_1.up)('sm')} {
		font-size: 1rem;
	}
`;
exports.HeaderTitle = styled_components_1.default.div `
	font-weight: bold;
	font-size: 1.25rem;
	color: ${({ theme }) => theme.color.white};
	margin-bottom: 0.5rem;
	${(0, styled_breakpoints_1.up)('sm')} {
		font-size: 2rem;
	}
`;
exports.SubNavigationContentWrapper = styled_components_1.default.div `
	max-width: ${({ theme }) => theme.breakpoints.xl};
	padding: 0 1rem;
	margin: auto;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
exports.MenuHeaderTitle = styled_components_1.default.div `
	font-weight: bold;
	font-size: 1rem;
	margin: 0 0.5rem;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: keep-all;
	overflow: hidden;
	color: ${({ theme }) => theme.color.brand3};
`;
exports.SubscribersWrapper = styled_components_1.default.div `
	white-space: nowrap;
	display: inline-flex;
	align-items: center;
`;
exports.SubscribersText = styled_components_1.default.div `
	font-size: 1rem;
	color: ${({ theme }) => theme.color.brand3};
`;
exports.CompanyWebsiteLink = styled_components_1.default.a `
	&,
	&:link,
	&:visited,
	&:focus {
		color: ${props => props.theme.color.white};
		text-decoration: underline;
	}
`;
exports.StyledBadge = (0, styled_components_1.default)(elements_1.Badge) `
	position: relative;
	font-size: unset;
	line-height: unset;
	color: unset;
`;
exports.CompanySubscriptionHeader = styled_components_1.default.div `
	transition: all 0.2s ease;
	z-index: 999;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	position: sticky;
	background: ${props => props.theme.color.brand5};
	top: ${({ isMenuSticked }) => (isMenuSticked ? '5rem' : 0)};
	height: 3rem;
	width: 100%;
	padding: 0 1.5rem;
`;
exports.CircleIconWrapper = styled_components_1.default.div `
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 0.5rem 0 0;
	padding: 0.5rem;
	border: 1px solid;
	width: 1.5rem;
	height: 1.5rem;
`;
exports.BannerWrapper = styled_components_1.default.div `
	max-width: ${({ theme }) => theme.breakpoints.xl};
	width: 100%;
	z-index: 1;
`;
exports.BannerContentWrapper = styled_components_1.default.div `
	padding: 1rem 1rem 0;
	width: 100%;

	${(0, styled_breakpoints_1.up)('md')} {
		width: 37.5%;
		max-width: 37.5%;
		margin-left: auto;
	}
	${(0, styled_breakpoints_1.up)('lg')} {
		width: 25%;
		max-width: 25%;
		margin-left: auto;
	}
`;
